import React, { useEffect, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useForm, useField } from 'react-final-form';
import { setError } from '../../../../../actions';
import { setCoordinates } from '../../../../../utils/helpers/common';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { getTownships } from '../../../../../api/queries';
import { SelectProps } from '../types';
import { LocationsSelect } from '../LocationsSelect';

const VillageSelectComponent: React.FC<SelectProps> = ({
  setInitCoordinates,
  setShouldRenderMap
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { change } = useForm();

  const { input: regionIdField } = useField(FORM_VALUES.locationId, {
    subscription: { value: true }
  });
  const { input: villageNameField } = useField(FORM_VALUES.villageName, {
    subscription: { value: true }
  });
  const { input: villageIdField } = useField(FORM_VALUES.villageId, {
    subscription: { value: true }
  });

  const regionId = regionIdField.value;
  const selectedVillageName = villageNameField.value;
  const currentVillageId = villageIdField.value;

  const villageQueryVariables = { regionId };
  const { data, loading, error } = useQuery(getTownships, {
    variables: villageQueryVariables
  });

  const villagesData = data?.townships || [];

  const onChangeRadioHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    const villageId = e?.target.value;
    change(FORM_VALUES.villageId, villageId);
    const villageData = villagesData.find(village => village.id === villageId);
    change(FORM_VALUES.villageName, villageData?.name?.trim());
    setCoordinates(villageData, setInitCoordinates);
    setShouldRenderMap(false);
    change(FORM_VALUES.coordinates, '');
  };

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  if (!data?.townships.length) return null;

  const selectAndModalCypress = 'item-form-village';
  const selectTitleAndPlaceholder = t('new_ad.village');

  return (
    <LocationsSelect
      loading={loading}
      inputStat="item-form-find-village"
      inputPlaceholder={t('new_ad.find_village')}
      selectCypress={selectAndModalCypress}
      modalCypress={selectAndModalCypress}
      selectTitleAndPlaceholder={selectTitleAndPlaceholder}
      selectValue={selectedVillageName}
      contentContainerCypress="item-form-village__container"
      radioCypress="location"
      radioName="select-township"
      currentValue={currentVillageId}
      data={villagesData}
      fieldName={FORM_VALUES.villageId}
      onSelect={onChangeRadioHandler}
    />
  );
};

export const VillageSelect = memo(VillageSelectComponent);
